import { ExperiencePerformanceTypes, UFOExperience, ExperienceTypes } from '@atlassian/ufo';

export const migrateConnectedProjectToAgsExperience = new UFOExperience(
	'jira-business.calendar.migrate-connected-project-to-ags-experience',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);
